/* eslint-disable css-modules/no-unused-class */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// classnames
import classNames from 'classnames';
// jl-design-system
import Form from 'jl-design-system/components/form/Form';
import { TertiaryButton } from 'jl-design-system/elements/button/Button';
import { QUANTITY_INPUT } from 'jl-design-system/form/fields';
import LoadingSpinner from 'jl-design-system/components/loading-spinner/LoadingSpinner';
// lodash
import get from 'lodash/get';
import includes from 'lodash/includes';
import find from 'lodash/find';
// components
import EditBasketItemOverlay from '../edit-basket-item-overlay/EditBasketItemOverlay';
import ProductImageWithMagnifier from '../product-image-with-magnifier/ProductImageWithMagnifier';
import Brand from '../brand/Brand';
// config
import getItemQuantityFormConfig, { getFormId } from '../../utils/form/configs/itemQuantity';
// constants
import deliveryConstants from '../../constants/deliveryConstants';
import editBasketConstants from '../../constants/editBasketConstants';
// helpers
import { getSubtotalText } from '../order-item/OrderItemHelper';
import { shouldShowCollectionHelpText } from '../../utils/collection/collectionHelp';
// utils
import isItemFabric from '../../utils/orderform/isItemFabric';
// styles
import styles from './edit-basket-item.scss';

export class EditBasketItem extends PureComponent {

  static propTypes = {
    children: PropTypes.node,
    deliveries: PropTypes.arrayOf(PropTypes.object),
    disabled: PropTypes.bool,
    handleQuantityChange: PropTypes.func,
    handleRemoveItem: PropTypes.func,
    hideItemRemoveOverlay: PropTypes.func,
    isChildItem: PropTypes.bool,
    isFirstChild: PropTypes.bool,
    isItemUpdating: PropTypes.bool,
    isProcessing: PropTypes.bool,
    item: PropTypes.shape({
      availability: PropTypes.shape({
        preOrder: PropTypes.bool,
      }),
      brand: PropTypes.string,
      id: PropTypes.string,
      imageUrl: PropTypes.string,
      name: PropTypes.string,
      partnerDiscount: PropTypes.string,
      priceHistory: PropTypes.shape({}),
      quantity: PropTypes.number,
      subtotal: PropTypes.string,
      subtotalDiscounted: PropTypes.string,
    }),
    lastItemInBasket: PropTypes.bool,
    maxValue: PropTypes.number,
    onFormSubmit: PropTypes.func,
    overlayType: PropTypes.oneOf([
      '',
      editBasketConstants.REMOVE_ITEM,
      editBasketConstants.OUT_OF_STOCK_ITEM,
    ]),
    partnerDiscountEnabled: PropTypes.bool,
    removeItemApiCallActive: PropTypes.bool,
    showCollectionHelp: PropTypes.bool,
    showItemRemoveOverlay: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    deliveries: [],
    disabled: false,
    handleQuantityChange: window.defaultFunc,
    handleRemoveItem: window.defaultFunc,
    hideItemRemoveOverlay: window.defaultFunc,
    isChildItem: false,
    isFirstChild: false,
    isItemUpdating: false,
    isProcessing: false,
    item: {},
    lastItemInBasket: false,
    maxValue: 0,
    onFormSubmit: window.defaultFunc,
    overlayType: '',
    partnerDiscountEnabled: false,
    removeItemApiCallActive: false,
    showCollectionHelp: false,
    showItemRemoveOverlay: window.defaultFunc,
  };

  showItemRemoveOverlay = () => {
    const { item: { id }, showItemRemoveOverlay } = this.props;
    showItemRemoveOverlay(id);
  };

  onRemoveItemYes = () => {
    const { item: { id }, handleRemoveItem, lastItemInBasket, isChildItem } = this.props;
    handleRemoveItem(id, lastItemInBasket, isChildItem);
  };

  onRemoveItemNo = () => {
    const { item: { id }, hideItemRemoveOverlay } = this.props;
    hideItemRemoveOverlay(id);
  };

  render() {
    const {
      deliveries,
      isProcessing,
      disabled,
      item,
      maxValue,
      handleQuantityChange,
      partnerDiscountEnabled,
      onFormSubmit,
      children,
      isChildItem,
      overlayType,
      isItemUpdating,
      lastItemInBasket,
      removeItemApiCallActive,
      showCollectionHelp,
      isFirstChild,
    } = this.props;

    const {
      availability = {},
      brand,
      id,
      imageUrl,
      name,
      partnerDiscount,
      quantity,
      subtotal,
      subtotalDiscounted,
      priceHistory: {
        reducedToClear,
        originalSubtotal,
      } = {},
    } = item;

    const delivery = find(deliveries, d => includes(d.itemIds, id));
    const isTradePlace = get(delivery, 'type', '') === deliveryConstants.TRADEPLACE;
    const noAmend = isTradePlace;
    const hasChildItems = React.Children.count(children) > 0;
    const renderImage = !!(imageUrl && !isChildItem);

    const formId = getFormId(id);
    const config = getItemQuantityFormConfig({
      item,
      changeHandler: handleQuantityChange(formId),
      isItemFabric: isItemFabric(item),
      maxValue,
      isTradePlace,
    });

    const itemDetailsContainerClassnames = classNames(styles.itemDetailsContainer, {
      [styles.fabricItem]: isItemFabric(item),
      [styles.itemDetailsChildContainer]: isChildItem,
    });

    const itemInfoContainerClassnames = classNames(styles.itemInfoContainer, {
      [styles.childInfoContainer]: isChildItem,
    });

    const removeItemsClassnames = classNames(styles.removeButton, {
      [styles.removeChildButton]: isChildItem,
    });

    const itemContainerClassnames = classNames(styles.itemContainer, {
      [styles.childItemContainer]: isChildItem,
    });

    const itemInnerContainerClassnames = classNames(styles.itemInnerContainer, {
      [styles.childItemInnerContainer]: isChildItem,
    });

    const formDisabled = disabled || noAmend || !!overlayType;
    const removeButtonDisabled = disabled || !!overlayType;
    const headingId = `order-item-name-${id}`;

    return (
      <div
        key={id}
        className={itemContainerClassnames}
        data-test={isChildItem ? 'edit-basket-child-item' : 'edit-basket-item'}
      >

        <div className={itemInnerContainerClassnames}>

          {
            renderImage &&
              <ProductImageWithMagnifier
                imageUrl={imageUrl}
                name={name}
                showMagnifyingIcon
              />
          }
          {
            isFirstChild &&
            <p>Additional services</p>
          }

          <div className={itemInfoContainerClassnames} data-test="edit-basket-item-info">
            <div
              className={styles.itemHeader}
            >
              {
                isChildItem &&
                <h4
                  data-test="order-item-name"
                  id={headingId}
                >
                  {name}
                </h4>
              }
              {
                !isChildItem &&
                <div>
                  <Brand brand={brand} />
                  <p
                    data-test="order-item-name"
                    id={headingId}
                  >
                    {name}
                  </p>
                </div>
              }

              <TertiaryButton
                aria-describedby={headingId}
                className={removeItemsClassnames}
                data-test="remove-item-button"
                disabled={removeButtonDisabled}
                onClick={this.showItemRemoveOverlay}
              />
            </div>

            {
              showCollectionHelp &&
              <p><strong>Collection unavailable</strong></p>
            }

            {
              availability.preOrder &&
              <p>Pre-order</p>
            }

            <div className={itemDetailsContainerClassnames} data-test="edit-basket-item-details">

              <Form
                config={config}
                data-test="edit-basket-item-form"
                disabled={formDisabled}
                enableReinitialize
                form={config.id}
                initialValues={{ [QUANTITY_INPUT.id]: (quantity && quantity.toString()), itemId: id }}
                onSubmit={onFormSubmit}
                useFormValidationErrorsAlertMessage={false}
              />

              {
                isChildItem &&
                  getSubtotalText(
                    partnerDiscount,
                    partnerDiscountEnabled,
                    false,
                    subtotal,
                    subtotalDiscounted,
                    styles,
                    reducedToClear,
                    originalSubtotal,
                    true,
                  )
                }

              <div className={styles.itemSubtotalContainer} data-test="edit-basket-item-subtotal-container">
                {
                  isItemUpdating &&
                  <LoadingSpinner className={styles.spinner} />
                }
                {
                  !isItemUpdating && !isChildItem &&
                  <>
                    {
                      getSubtotalText(
                        partnerDiscount,
                        partnerDiscountEnabled,
                        false,
                        subtotal,
                        subtotalDiscounted,
                        styles,
                        reducedToClear,
                        originalSubtotal,
                        true,
                      )
                    }
                  </>
                }
              </div>
            </div>
          </div>
        </div>

        {
          overlayType &&
          <EditBasketItemOverlay
            disabled={isProcessing}
            hasChildItems={hasChildItems}
            lastItemInBasket={lastItemInBasket}
            onRemoveNo={this.onRemoveItemNo}
            onRemoveYes={this.onRemoveItemYes}
            removeItemApiCallActive={removeItemApiCallActive}
            type={overlayType}
          />
        }

        {
          hasChildItems &&
          <div className={styles.childItemsContainer} data-test="edit-basket-item-children">
            {children}
          </div>
        }

      </div>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  return {
    showCollectionHelp: shouldShowCollectionHelpText({
      isChildItem: ownProps?.isChildItem,
      id: ownProps?.item.id,
      state,
    }),
  };
}
export default connect((state, ownProps) => mapStateToProps(state, ownProps))(EditBasketItem);
